import React from "react";
import { Link } from "react-router-dom";
import PDFIcon from "../Images/pdfIcon.png";

const CodeNPolicies = () => {
  const certificates = [
    {
      link: "Code for independent Directors Policy",
      title: "Code-for-independent-Directors-Policy.pdf",
    },
    {
      link: "Code of Conduct Policy",
      title: "Code-of-Conduct-Policy.pdf",
    },
    {
      link: "Policy on Insider Trading",
      title: "Policy-on-Insider-Trading.pdf",
    },
    {
      link: "Fair Disclosures Policy UPSI",
      title: "Fair-Disclosures-Policy-UPSI.pdf",
    },
    {
      link: "Nomination and remuneration Policy",
      title: "Nomination-and-remuneration-Policy.pdf",
    },
    {
      link: "Policy for detrmining subsidiaries",
      title: "Policy-for-detrmining-subsidiaries.pdf",
    },
    {
      link: "Policy on Criteria for determining Materiality of Events or Information for disclosure to Stock Excha",
      title:
        "Policy-on-Criteria-for-determining-Materiality-of-Events or-Information-for-disclosure-to-Stock-Excha.pdf",
    },
    {
      link: "Policy on Insider Trading",
      title: "Policy-on-Insider-Trading.pdf",
    },
    {
      link: "Policy on materiality of related party transactions",
      title: "Policy-on-materiality-of-related-party-transactions.pdf",
    },
    {
      link: "Policy Payments",
      title: "Policy-Payments.pdf",
    },

    {
      link: "Preservation of Documents Policy",
      title: "Preservation-of-Documents-Policy.pdf",
    },
    {
      link: "Risk Management Policy",
      title: "Risk-Management-Policy.pdf",
    },

    {
      link: "Preservation of Documents Policy",
      title: "Preservation-of-Documents-Policy.pdf",
    },
  ];

  const downloadFile = (event, status) => {
    event.preventDefault();

    if (status) {
      const formattedUrl = `https://essexmpl.com/Pdf/Policies/${status}`;
      window.open(formattedUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className="py-80">
      <div className="container">
        <div className="row">
          {certificates.map((certificate, id) => (
            <div className="col-md-6 col-lg-4" key={id}>
              <div className="team-item">
                <Link
                  to={"#"}
                  onClick={(e) => downloadFile(e, certificate.title)}
                  target="_blank"
                >
                  <img src={PDFIcon} alt="thumb" />
                  <div className="team-content">
                    <div className="team-bio">
                      <h5>
                        <a href="team.html">{certificate.title}</a>
                      </h5>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CodeNPolicies;
